import React, { useState } from 'react'
import AppNavbar from '../../components/Navbar';
import Group13872 from '../../images/Group13872.png'
import { Container , Card , Col , Row , Button} from 'react-bootstrap'
import { Link } from 'react-router-dom'
import AboutTripz from '../../images/AboutTripz.png'
import mission from '../../images/mission.png'
import brandlogo from '../../images/brandlogo.png'
import { FiArrowRight } from 'react-icons/fi';
import sammy from '../../images/sammy.png'
import princess from '../../images/princess.png'
import abouthome from '../../images/abouthome.png'
import Footer from '../../images/Footer.png'
import yellowlogo from '../../images/yellowlogo.svg';
import strip from '../../images/strip.svg'
import { CloseButton, Form} from 'react-bootstrap';
import Chatbot from 'react-chatbot-kit';

import 'react-chatbot-kit/build/main.css'
import config from '../../chatbot/config';
import ActionProvider from '../../chatbot/ActionProvider';
import MessageParser from '../../chatbot/MessageParser';
import chatIcon from '../../images/chat-icon.svg'
import './about.css'
import { useNavigate } from 'react-router-dom';



const About = () => {
  const navigate = useNavigate();
  const [showChat, setShowChat] = useState(false);
  const [validated, setValidated] = useState(false);

  const handleSubscribeSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(false)
    } else{

    setValidated(true);
    navigate('/subscribe')}
  };
  
    const toggleChat = () => {
      setShowChat((prevState) => !prevState);
      
  };
  const closeChat = () => {
    setShowChat(false);
};
  return (
    <div>
      
        <AppNavbar/>
  
    <Card className="border-none text-white"style={{borderRadius:'none'}}>
      <Card.Img src={abouthome} alt="AboutImage" style={{ width: '100%',maxHeight:'650px', minHeight:'400px'}}/>
      <Card.ImgOverlay style={{}} className='about-cover align-items-center'>
      <div className='ms-2 ms-md-5 my-5 py-5' style={{background:'none', borderRadius:'none', maxWidth:'43rem'}}>
        <div className='d-flex gap-3'>
          <img src={strip} alt='strip' className='strip'/>
        <Card.Title className='about-title' >Let us help you find the perfect place to go</Card.Title>
        </div>
        <Card.Text className='sub-about-title mt-2 ms-4' style={{fontSize:'28px'}}>
        Explore the magic of adventure with us 
        </Card.Text>
</div>
      </Card.ImgOverlay>
    </Card>

   
       <Container fluid className='p-3 p-md-4 p-lg-5 '>
        <Card className="mb-5 mt-5 border-0 mx-lg-5 mx-0 d-md-flex d-none" style={{borderRadius:'none'}}>
          <Row className="">
          <Col className="">
            <Card.Body className="">
              <h2 className="acc-section-header">About Tripz</h2>
              <Card.Text className="mt-4" style={{fontFamily: 'Lora',fontSize: '18px'}}>
                Welcome to our travel planning website! We're here to help you plan the trip of a lifetime. Our team of experienced travelers and travel experts have curated an extensive database of destinations, activities, accommodations, and more to make your travel planning experience as easy and enjoyable as possible.
                    <br/><br/>
                    At our website, we believe that travel is not just about the destination, but also the journey. That's why we provide comprehensive information about travel options, including flights, trains, buses, and rental cars. We also offer advice on travel insurance, visa requirements, and other important travel details that can make a big difference in your trip.
               
              </Card.Text>
             
            </Card.Body>
          </Col>
          <Col md={6} lg={3} className="">
            <Card.Img src={AboutTripz} className="" alt="AboutTripz" style={{width:'100%'}}/>
          </Col>
        </Row>
      </Card>
      <Card className="mb-5 mt-5 border-0 mx-lg-5 mx-0 d-md-none d-block" style={{borderRadius:'none'}}>
      <h2 className="acc-section-header mb-4">About Tripz</h2>
        <Row className="">
        <Col md={6} lg={3} className="">
            <Card.Img src={AboutTripz} className="" alt="AboutTripz" style={{width:'100%'}}/>
          </Col>
          <Col className="">
            <Card.Body className="">
              
              <Card.Text className="mt-4" style={{fontFamily: 'Lora',fontSize: '18px'}}>
                Welcome to our travel planning website! We're here to help you plan the trip of a lifetime. Our team of experienced travelers and travel experts have curated an extensive database of destinations, activities, accommodations, and more to make your travel planning experience as easy and enjoyable as possible.
                    <br/><br/>
                    At our website, we believe that travel is not just about the destination, but also the journey. That's why we provide comprehensive information about travel options, including flights, trains, buses, and rental cars. We also offer advice on travel insurance, visa requirements, and other important travel details that can make a big difference in your trip.
               
              </Card.Text>
             
            </Card.Body>
          </Col>
         
        </Row>
      </Card>
      <Card className="mb-3 mt-5 mx-lg-5 mx-0 border-0" style={{borderRadius:'none'}}>
      <h2 className="acc-section-header d-flex d-md-none mb-4">Our Mission</h2>
        <Row className="">
           <Col className="" md={6} lg={3}>
            <Card.Img src={mission} className="" alt="mission" style={{width: '100%', height: '100&'}}/>
          </Col>
          <Col className="">
            <Card.Body className="">
              <h2 className="acc-section-header d-md-flex d-none">Our Mission</h2>
              <Card.Text className="card-text" style={{fontFamily: 'Lora',fontSize: '18px'}}>
                Our mission is to empower and inspire people to explore the world and create unforgettable travel experiences. We believe that travel has the power to broaden horizons, break down barriers, and foster a deeper understanding and appreciation of other cultures and ways of life.
                    <br/><br/>
                    At the heart of our mission is a passion for travel and a commitment to sustainability and responsible tourism. We believe that travel has the potential to make a positive impact on the world, and we strive to promote ethical and sustainable travel practices in everything we do
              
                    </Card.Text>
             
             </Card.Body>
           </Col>
          
         </Row>
      </Card>
     
    </Container>
    <Container fluid style={{
    backgroundColor: '#008080'}} className='py-4 px-md-5 px-2'>
      <div className="services">
        <h2 className="text-center value1 mb-5" style={{color: 'white'}}>Our Unique Services</h2>
        <Row className="text-center gap-0 gapxxl--5 ">
          <Col xs={12} md={true} className=" text-center mb-3">
            <h5 className="my-3" style={{color: 'white'}}>Flight Bookings</h5>
            <p style={{color: 'white'}} className='px-xxl-5'>Allow users to search and book flights to their desired destination. </p>
          </Col>
          <Col xs={12} md={true} className=" text-center mb-3">
            <h5 className="my-3" style={{color: 'white'}}>Hotel Bookings</h5>
            <p style={{color: 'white'}} className='px-lg-5'>Offer a wide range of accommodation options such as hotels, resorts, and vacation rentals. </p>
          </Col>
          <Col xs={12} md={true} className=" text-center mb-3">
            <h5 className="my-3" style={{color: 'white'}}>Destination Guide</h5>
            <p style={{color: 'white'}} className='px-lg-5'>Provide comprehensive information about popular destinations, including things to see and do, best time to visit, local customs, and culture. </p>
          </Col>
        </Row>
        <Row className="text-center gap-0 gap-lg-5">
          <Col xs={12} md={true} className=" text-center mb-3">
            <h5 className="my-3" style={{color: 'white'}}>Car Rentals</h5>
            <p style={{color: 'white'}}className='px-lg-5'> Car rentals: Allow users to rent cars to explore their destination.</p>
          </Col>
          <Col xs={12} md={true} className=" text-center mb-3"> 
            <h5 className="my-3" style={{color: 'white'}}>Tour Packages</h5>
            <p style={{color: 'white'}}className='px-lg-5'>Offer customized and pre-planned tour packages to popular destinations.</p>
          </Col>
          <Col xs={12} md={true} className=" text-center mb-3">
            <h5 className="my-3" style={{color: 'white'}}>Travel Insurance</h5>
            <p style={{color: 'white'}} className='px-lg-5'>Provide travel insurance options to protect travelers from unforeseen circumstances.</p>
          </Col>
        </Row>
      </div>
    </Container>
    <Container fluid className='p-3 p-md-4 p-lg-5 '>
        <Card className="mb-5 mt-5 border-0 mx-lg-5 mx-0 " style={{borderRadius:'none'}}>
        <Row className="gap-4">
          <Col xs={12} md={7} lg={8} className="">
            <Card.Body className="">
              <Card.Title className="sub-about-title mb-3 fw-bold">Our unique brand and identity together with our awesome customer services has enable us stand out since 2020.</Card.Title>
              <div className="d-block d-md-none my-4 text-center">
              <Card.Img src={brandlogo}  alt="brandLogo" style={{width: '50%'}}/>
              </div>
              <Card.Text className="">
                 Our website is designed to be user-friendly, with intuitive navigation and search functions that allow you to quickly find what you're looking for. Whether you're planning a solo adventure, a romantic getaway, or a family vacation, our website has everything you need to plan your trip with ease
            <br/><br/>
            We're committed to providing our users with the most accurate and up-to-date information possible. Our team of travel experts works tirelessly to ensure that our website is constantly updated with the latest travel news, destination information, and insider tips
              </Card.Text>
             
            </Card.Body>
          </Col>
          <Col className="d-md-flex d-none">
            <Card.Img src={brandlogo} className="" alt="brandLogo" style={{width: '50%'}}/>
          </Col>
        </Row>
      </Card>
</Container>
      

      <Card  className=" mb-3" style={{ width: '100%' , borderRadius:'none'}}>
            <Card.Img src={Footer} alt="about" style={{ width: '100%', minHeight:'300px', maxHeight:'400px' }} />
            <Card.ImgOverlay style={{background:'none', borderRadius: 'none', maxWidth:'50rem'}}className='border-0 text-align-center text-center p-3 p-md-5 m-auto my-3 my-sm-5 '>
            <h3 className="welcome text-white  ">Do you want to stay updated with travel news?</h3>
    <p className="mt-4 text-center unsubscribe">Subscribe to our Newsletter</p>
    <div className=" ">
    <Form noValidate validated={validated} onSubmit={handleSubscribeSubmit} className='d-flex text-center gap-2 justify-content-center mt-3 '>
        <Form.Group >
          <Form.Control type='email' placeholder='Enter email address' className='py-2' required/>
        </Form.Group>
        <button className='subscribe-button border-0'  style={{
    backgroundColor: '#008080'}}>Subscribe</button>
      </Form>
     
    </div>  
          
           </Card.ImgOverlay>
    
      </Card>

    <div className='chat-widget-container'>
          {!showChat && (
          <div className="chat-widget-icon" onClick={toggleChat}>
            <img src={chatIcon} alt='chatIcon'/>
          </div>
        )}
         
       {showChat && (
        <div>
          <div onClick={closeChat} className='close-chat'>
          <CloseButton variant="white"style={{position:'absolute'}} />
          </div>
          <Chatbot 
         
          config={config} messageParser={MessageParser} actionProvider={ActionProvider} closeChat={closeChat}
          />
        </div>
       )}
      
      </div>

     
   
    </div>
  )
}

export default About
